<template>
  <div class="food">
    <Food />
  </div>
</template>

<script>
// @ is an alias to /src
import Food from "@/components/Food.vue";

export default {
  name: "FoodRoute",
  components: {
    Food
  }
};
</script>
